import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { toast } from "react-toastify";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
    root: {
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.background.default,
    },
    paper: {
        backgroundColor: theme.palette.type === "light" ? "rgba(255, 255, 255, 0.85)" : "rgba(30, 30, 30, 0.85)",
        backdropFilter: "blur(20px)",
        borderRadius: "24px",
        padding: theme.spacing(4, 6),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
        border: "1px solid rgba(255, 255, 255, 0.18)",
        maxWidth: "450px",
        width: "100%",
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        borderRadius: "12px",
        height: "48px",
        fontWeight: "bold",
    },
}));

const ResetPassword = () => {
    const classes = useStyles();
    const { token } = useParams();
    const history = useHistory();
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            toast.error("Las contraseñas no coinciden.");
            return;
        }

        setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, password });
            toast.success(i18n.t("common.toasts.success"));
            history.push("/login");
        } catch (err) {
            toast.error(err.response?.data?.error || i18n.t("common.toasts.error"));
        }
        setLoading(false);
    };

    return (
        <Container component="main" maxWidth="xs" className={classes.root} dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
            <CssBaseline />
            <div className={classes.paper}>
                <Typography component="h1" variant="h5" style={{ fontWeight: "bold", marginBottom: "20px" }}>
                    Nueva Contraseña
                </Typography>
                <form className={classes.form} onSubmit={handleSubmit}>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Nueva Contraseña"
                        type="password"
                        id="password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="confirmPassword"
                        label="Confirmar Contraseña"
                        type="password"
                        id="confirmPassword"
                        value={confirmPassword}
                        onChange={e => setConfirmPassword(e.target.value)}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        disabled={loading}
                    >
                        {loading ? i18n.t("settings.brandKitIA.saving") : i18n.t("globalModals.password.save")}
                    </Button>
                </form>
            </div>
        </Container>
    );
};

export default ResetPassword;
